import { useMemo } from "react"

import { useProductConfigurationModelsQuery } from "entities/dim-configuration/graphql/product-configuration.queries.generated"

export function useProductConfigurationModel(
  productType: string | null | undefined
) {
  const { data: models, loading: isLoading } =
    useProductConfigurationModelsQuery()

  const model = useMemo(
    () => models?.configurationModels?.models?.find(m => m.id === productType),
    [models, productType]
  )

  return {
    model,
    isLoading
  }
}
